<template>
  <div class="pathSet">
    <!-- 两个按钮 -->
    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px">
      <el-radio-button label="1">小程序</el-radio-button>
      <el-radio-button label="2">APP</el-radio-button>
    </el-radio-group>
    <!-- 卡片区 -->
    <el-card class="my_card" shadow="never">
      <div class="title">
        <p class="p1">
          <span>所属{{ text }}</span>
          <el-select :value="'请选择' + text" placeholder="请选择活动区域">
            <el-option
              :label="'请选择' + text"
              :value="'请选择' + text"
            ></el-option>
          </el-select>
          <span>页面路径</span>
          <el-input
            placeholder="请输入路径名称搜索"
            suffix-icon="el-icon-search"
            v-model="input2"
          >
          </el-input>
        </p>
        <p>
          <el-button
            @click="dialogFormVisible = true"
            class="addbtn"
            type="primary"
            round
            icon="el-icon-plus"
            >新增页面路径</el-button
          >
        </p>
      </div>
      <!-- 表格 -->
      <el-table
        :header-cell-style="{ background: '#F5F5F5', color: '#333333' }"
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column prop="d1" label="所属小程序"> </el-table-column>
        <el-table-column prop="d2" label="页面名称"> </el-table-column>
        <el-table-column prop="d3" label="页面路径"> </el-table-column>
        <el-table-column prop="d4" label="页面参数"> </el-table-column>
        <el-table-column prop="d5" label="创建人"> </el-table-column>
        <el-table-column prop="d6" label="创建时间"> </el-table-column>
        <el-table-column prop="d7" label="操作">
          <template slot-scope="scope">
            <el-button class="minibtn" type="text" size="mini" @click="onedit"
              >编辑</el-button
            >
            <el-button class="minibtn" type="text" size="mini" @click="remove1"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        class="my-page"
        background
        :page-sizes="[10, 20, 30, 40]"
        :page-size="10"
        layout="prev,pager,next,sizes,jumper"
        :total="70"
      >
      </el-pagination>
    </el-card>

    <div class="dialog">
      <el-dialog
        :title="txt + text + '页面路径'"
        :visible.sync="dialogFormVisible"
      >
        <el-form :model="form" :rules="rules">
          <!--1  -->
          <el-form-item
            :label="'所属' + text"
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-select v-model="form.name" :placeholder="'请选择所属' + text">
              <el-option :label="text + '1'" value="1"></el-option>
              <el-option :label="text + '2'" value="2"></el-option>
              <el-option :label="text + '3'" value="3"></el-option>
            </el-select>
          </el-form-item>
          <!-- 2 -->
          <el-form-item
            label="页面名称"
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              placeholder="请输入页面名称"
              v-model="form.name1"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 3 -->
          <el-form-item
            label="页面路径"
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              placeholder="请输入页面路径"
              v-model="form.name2"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <!-- 4 -->
          <el-form-item
            label="页面参数"
            :label-width="formLabelWidth"
            prop="name"
          >
            <el-input
              placeholder="请输入页面参数"
              v-model="form.name3"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false;edit = false">取 消</el-button>
          <el-button @click="dialogFormVisible = false" type="primary"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //编辑
      edit: false,
      //
      input2: "",
      // 控制顶部两个按钮切换
      tabPosition: "1",
      //弹框
      dialogFormVisible: false,
      form: {
        name: "",
        name1: "",
        name2: "",
        name3: "",
      },
      //验证
      rules: {
        name: [{ required: true, message: "不可为空", trigger: "blur" }],
      },
      formLabelWidth: "120px",
    };
  },
  computed: {
    txt() {
      if (this.edit) {
        return "编辑";
      } else {
        return "新增";
      }
    },
    text() {
      if (this.tabPosition == 1) {
        return "小程序";
      } else {
        return "APP";
      }
    },
    tableData() {
      if (this.tabPosition == 1) {
        return [
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-小程序",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
        ];
      } else {
        return [
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
          {
            d1: "小橘帮帮-APP",
            d2: "国庆特惠活动",
            d3: "/lndex",
            d4: "/id=01",
            d5: "吴彦祖",
            d6: "2021.07.07 18:00",
          },
        ];
      }
    },
  },
  methods: {
    //点编辑
    onedit() {
      this.edit = true;
      this.dialogFormVisible = true;
    },
    //点删除
    remove1() {
      this.$confirm("是否确定删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        roundButton: true,
        type: "warning",
      }).then(() => {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
      });
    },
  },
};
</script>

<style lang='less'>
.pathSet {
  padding: 20px;
  .el-radio-button:first-child .el-radio-button__inner {
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 18px 0 0 18px;
  }
  .el-radio-button:last-child .el-radio-button__inner {
    width: 106px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    border-radius: 0 18px 18px 0;
  }
  .my_card {
    height: 800px;
    .el-card__body {
      padding: 0 !important;
    }
    .title {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      p {
        display: flex;
        align-items: center;
        font-size: 14px;
        span {
          margin-left: 10px;
          width: 70px;
          display: inline-block;
          word-break: normal;
        }
        .el-select .el-input {
          width: 142px;
          height: 40px;
          margin-left: 10px;
          transform: translate(0px, 5px);
          font-size: 14px;
        }
        .el-input--suffix {
          width: 200px;
          height: 40px;
          transform: translate(0px, 5px);
        }
        .addbtn {
          width: 137px;
          height: 36px;
          span {
            margin-left: 5px;
            margin-right: 10px;
          }
        }
      }
      .refresh {
        border-color: #2e6cf6;
        color: #2e6cf6;
      }
    }
    .el-table {
      border: 0;
      .cell {
        text-align: center;
        font-size: 12px;
      }
      .el-table__row {
        height: 51px;
      }
      .minibtn {
        font-size: 12px;
        color: #0091ff;
      }
      .el-switch {
        margin-right: 10px;
      }
      .el-tag {
        width: 74px;
        height: 24px;
        line-height: 24px;
        border-radius: 12px;
      }
    }
    //分页样式
    .my-page {
      margin-top: 15px;
      .el-pager li {
        background-color: #fff;
      }
      .btn-prev {
        background-color: #fff;
      }
      .btn-next {
        background-color: #fff;
      }
      .el-pagination__jump {
        margin-left: 10px;
      }
    }
  }
  .dialog {
    .el-dialog__body {
      margin-left: 50px;
      margin-top: 48px;
      margin-bottom: 93px;
      .el-input__inner {
        width: 424px;
        height: 32px;
        background: #f6f6f6;
        border: 0;
      }
    }
    .hx {
      position: absolute;
      left: 0;
      bottom: 70px;
      width: 100%;
      height: 1px;
      background: rgba(0, 0, 0, 0.09000000357627869);
    }
    .el-dialog__body {
      word-break: normal;
    }
    .dialog-footer {
      border-top: 1px solid #00000017;
      padding-top: 15px;
    }
  }
}
</style>